import { render, staticRenderFns } from "./Recommendations.vue?vue&type=template&id=18f5ea4a&scoped=true"
import script from "./Recommendations.vue?vue&type=script&lang=js"
export * from "./Recommendations.vue?vue&type=script&lang=js"
import style0 from "./Recommendations.vue?vue&type=style&index=0&id=18f5ea4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f5ea4a",
  null
  
)

export default component.exports